export interface ModelPreparation149Payload {
  id?: number;
  case?: number;
  generatedTxt?: string;
  modelPreparationStatus?: number;
  statusCategory?: string;
  statusDescription?: string;
  filingResponse?: string;
  filingCsv?: string;
  filingTime?: string;
  filingExpediente?: string;
  filingJustificante?: string;
  filingUrlPdf?: string;
  draftResponse?: string;
  draftCsv?: string;
  draftTime?: string;
  draftExpediente?: string;
  draftJustificante?: string;
  draftUrlPdf?: string;
  deliveryServerDraft?: string;
  deliveryPathDraft?: string;
  deliveryServerFiled?: string;
  deliveryPathFiled?: string;
  isDuplicated?: boolean;
}

function toNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function toBoolean(value: unknown): boolean | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  return undefined;
}

function toStringValue(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  const text = String(value).trim();
  return text.length > 0 ? text : undefined;
}

function toSerializedResponse(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (typeof value === 'string') {
    return toStringValue(value);
  }

  try {
    const serialized = JSON.stringify(value);
    return serialized === undefined ? undefined : serialized;
  } catch {
    return undefined;
  }
}

function extractId(input: any, field: string): number | undefined {
  const direct = toNumber(input?.[field]);
  if (direct !== undefined) {
    return direct;
  }
  return toNumber(input?.[field]?.id);
}

export function buildModelPreparation149Payload(input: any): ModelPreparation149Payload {
  const payload: ModelPreparation149Payload = {};

  const id = toNumber(input?.id);
  if (id !== undefined) payload.id = id;

  const caseId = extractId(input, 'case');
  if (caseId !== undefined) payload.case = caseId;

  const generatedTxt = toStringValue(input?.generatedTxt ?? input?.genratedTxt);
  if (generatedTxt !== undefined) payload.generatedTxt = generatedTxt;

  const modelPreparationStatus = extractId(input, 'modelPreparationStatus');
  if (modelPreparationStatus !== undefined) payload.modelPreparationStatus = modelPreparationStatus;

  const statusCategory = toStringValue(input?.statusCategory);
  if (statusCategory !== undefined) payload.statusCategory = statusCategory;

  const statusDescription = toStringValue(input?.statusDescription);
  if (statusDescription !== undefined) payload.statusDescription = statusDescription;

  const filingResponse = toSerializedResponse(input?.filingResponse);
  if (filingResponse !== undefined) payload.filingResponse = filingResponse;

  const filingCsv = toStringValue(input?.filingCsv);
  if (filingCsv !== undefined) payload.filingCsv = filingCsv;

  const filingTime = toStringValue(input?.filingTime);
  if (filingTime !== undefined) payload.filingTime = filingTime;

  const filingExpediente = toStringValue(input?.filingExpediente);
  if (filingExpediente !== undefined) payload.filingExpediente = filingExpediente;

  const filingJustificante = toStringValue(input?.filingJustificante);
  if (filingJustificante !== undefined) payload.filingJustificante = filingJustificante;

  const filingUrlPdf = toStringValue(input?.filingUrlPdf);
  if (filingUrlPdf !== undefined) payload.filingUrlPdf = filingUrlPdf;

  const draftResponse = toSerializedResponse(input?.draftResponse);
  if (draftResponse !== undefined) payload.draftResponse = draftResponse;

  const draftCsv = toStringValue(input?.draftCsv);
  if (draftCsv !== undefined) payload.draftCsv = draftCsv;

  const draftTime = toStringValue(input?.draftTime);
  if (draftTime !== undefined) payload.draftTime = draftTime;

  const draftExpediente = toStringValue(input?.draftExpediente);
  if (draftExpediente !== undefined) payload.draftExpediente = draftExpediente;

  const draftJustificante = toStringValue(input?.draftJustificante);
  if (draftJustificante !== undefined) payload.draftJustificante = draftJustificante;

  const draftUrlPdf = toStringValue(input?.draftUrlPdf);
  if (draftUrlPdf !== undefined) payload.draftUrlPdf = draftUrlPdf;

  const deliveryServerDraft = toStringValue(input?.deliveryServerDraft);
  if (deliveryServerDraft !== undefined) payload.deliveryServerDraft = deliveryServerDraft;

  const deliveryPathDraft = toStringValue(input?.deliveryPathDraft);
  if (deliveryPathDraft !== undefined) payload.deliveryPathDraft = deliveryPathDraft;

  const deliveryServerFiled = toStringValue(input?.deliveryServerFiled);
  if (deliveryServerFiled !== undefined) payload.deliveryServerFiled = deliveryServerFiled;

  const deliveryPathFiled = toStringValue(input?.deliveryPathFiled);
  if (deliveryPathFiled !== undefined) payload.deliveryPathFiled = deliveryPathFiled;

  const isDuplicated = toBoolean(input?.isDuplicated);
  if (isDuplicated !== undefined) payload.isDuplicated = isDuplicated;

  return payload;
}
